import { SHORTCUTS } from './constants';

export function initShortcuts(handlers) {
  function handler(e) {
    const { openPanel, closePanel, reset, highContrast, darkMode } = SHORTCUTS;
    if (e.key === closePanel.key && !e.altKey && !e.ctrlKey) {
      handlers.onClosePanel && handlers.onClosePanel(e);
      return;
    }
    if (!e.altKey || e.ctrlKey || e.metaKey) return;
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA' || e.target.tagName === 'SELECT') return;
    switch (e.key.toLowerCase()) {
      case openPanel.key:
        e.preventDefault();
        handlers.onOpenPanel && handlers.onOpenPanel(e);
        break;
      case reset.key:
        e.preventDefault();
        handlers.onReset && handlers.onReset(e);
        break;
      case highContrast.key:
        e.preventDefault();
        handlers.onHighContrast && handlers.onHighContrast(e);
        break;
      case darkMode.key:
        e.preventDefault();
        handlers.onDarkMode && handlers.onDarkMode(e);
        break;
    }
  }
  document.addEventListener('keydown', handler);
  return () => document.removeEventListener('keydown', handler);
}
